import { ProductGate } from "./ProductGate";

export function AthenaApp() {
  return <ProductGate appId="athena" />;
}
